import { Loader2 } from 'lucide-react'

function LoadingScreen() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="w-10 h-10 animate-spin text-primary-600" />
        <p className="text-grey-500">Loading...</p>
      </div>
    </div>
  )
}

export default LoadingScreen
